import React from 'react';
import { HABU_ENVIRONMENT } from 'utils/appConstants';
import { Redirect } from 'react-router-dom';
import { homepage } from 'utils/spaUrls';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useUpgradeUserType } from 'api/supportMode';


const SupportModeHandler = () => {
  const dispatch = useDispatch();
  const user = useSelector(state => state.session.user.user);
  const upgradeUserType = useUpgradeUserType();

  // Prevent support mode from being enabled in production
  if (HABU_ENVIRONMENT === 'production') {
    dispatch(showAlert({ message: 'Support Mode is disabled in production.', type: 'error' }));
    return (<Redirect to={homepage} />);
  }

  upgradeUserType.mutate({
    userID: user.ID,
  });

  return (<Redirect to={homepage} />);
};

export default SupportModeHandler;
